var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mappedComponent,{key:`${this.contents.type}-${this.contents.id}`,tag:"component",attrs:{"nestingLevel":this.nestingLevel,"contents":this.contents,"path":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }